import request from '@/utils/request'
// import store from '../store'
import md5 from 'js-md5'
export function loginByUsername(username, password) {
  const data = {
    logNo: username,
    passwd: md5(password)
  }
  // const data = {
  //   username,
  //   password
  // }
  return request({
    url: '/api/home/login',
    method: 'get',
    params: {
      logNo: data.logNo,
      passwd: data.passwd
    }
  })
}

export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo(rId) {
  return request({
    url: '/api/user/qryUserRoleProgramInfo',
    method: 'get',
    params: {
      roleId: rId
    }
  })
// return store.getters.roles
}

